import { call, put, takeLatest, select } from 'redux-saga/effects';
import { get } from 'lodash';
import pickBy from 'lodash/pickBy';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { getSortParams } from '../helpers/utils';
import { FETCH_NEW_BETS, FETCH_NEW_BETS_SUCCESS, FETCH_NEW_BETS_FAIL } from '../redux/BetsTables';
import { SET_LOADER } from '../redux/Loader';
import { NEW_BETS } from '../consts/navigation';

function* getNewBetsFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', NEW_BETS, 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', NEW_BETS, 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', NEW_BETS, 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', NEW_BETS, 'page']));
    const vehicleType = yield select((state) => state.vehicleType.vehicleType);

    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/${vehicleType}/bets`;
    const newBets = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_NEW_BETS_SUCCESS(newBets));
  } catch (error) {
    yield put(FETCH_NEW_BETS_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* GetNewBets() {
  yield takeLatest(FETCH_NEW_BETS, getNewBetsFlow);
}
